'use client'
import MyImage from '@/shared/components/myImage'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import { calculateAge, getImgURL } from '@/shared/utils'
import { useState } from 'react'
import ComparePlayerPopup from '../../comparePlayer/comparePlayerPopup'
// import adsData from '@/shared/google-ads/adsData.json'
// import GoogleAds from '@/shared/google-ads'
import ReviveAds from '@/shared/revive-ads'
import reviveAdsData from '@/shared/revive-ads/adsData.json'

type TeamHeaderProps = {
  name: string
  desc?: string

  team?: {
    sPlayingRole?: string
    aRanking?: any[]
    dBirthDate?: number
    oTeam?: any
    oImg?: {
      sUrl: string
    }
    oSeo?: {
      sSlug: string
    }
    _id: string
    oSeries?: {
      sGameFormat?: string
      nTotalMatches?: number
      nTotalTeams?: number
      dStartDate?: string | Date | number
      dEndDate?: string | Date | number
    }
  }
  showHeaderImg?: boolean
}

const PlayerHeader = ({ name, team }: TeamHeaderProps) => {
  const [isSearch, setIsSearch] = useState(false)
  function generateBettingStyle() {
    switch (team?.sPlayingRole) {
      case 'bat':
        return 'Batsman'
      case 'bowl':
        return 'Bowler'
      case 'all':
        return 'All Rounder'
      case 'wk':
        return 'Wicket Keeper'
      default:
        return ''
    }
  }

  // const { addTop } = adsData.data
  const { mobSm, desktopTop } = reviveAdsData.data

  return (
    <>
      <section className="py-6 md:py-8">
        {/* <div className='flex items-start justify-between mb-4'>
        <BreadcrumbNav customTitle={name}/>
      </div> */}
        <div
          className={`[&:not(:last-child)]:mb-2 flex gap-2.5 md:gap-8 items-start md:items-center`}
        >
          <div className=" w-[65px] md:w-[250px] shrink-0">
            <MyImage
              src={team?.oImg?.sUrl ? getImgURL(team?.oImg?.sUrl) : ''}
              alt={name}
              blurDataURL={BLUR_DATA_URL_BASE64}
              placeholder="blur"
              className="rounded-full object-cover"
              placeholderType="players"
              height={250}
              width={250}
              sizes="(max-width: 767px) 80px, (max-width: 991px) 80x, (max-width: 1190px) 200px, 80px"
            />
          </div>
          <div className={` relative flex flex-wrap flex-col text-xs flex-grow z-[1]`}>
            <span className=" absolute top-2/4 -translate-y-2/4 left-0 md:-left-6 text-[99px] md:text-[280px] -z-[1] font-bold text-[#646A6E] dark:opacity-[12%] opacity-[8%]">
              {team?.oTeam?.sAbbr}
            </span>
            <h1 className=" text-base md:leading-none md:text-[42px] text-textOffWhite mb-2 md:mb-3">
              {name}
            </h1>
            <div className="flex items-start capitalize mb-2 md:mb-4 text-xs md:text-lg text-TextOffPlayer">
              <p className={'flex items-center capitalize'}>
                {team?.oTeam?.oImg?.sUrl ? (
                  <span className="w-5 h-5 me-1 md:me-2">
                    <MyImage
                      src={team?.oTeam?.oImg?.sUrl ? getImgURL(team?.oTeam?.oImg?.sUrl) : ''}
                      alt={team?.oTeam?.sTitle}
                      className="rounded-full"
                      blurDataURL={BLUR_DATA_URL_BASE64}
                      placeholder="blur"
                      placeholderType="team"
                      height={20}
                      width={20}
                      sizes="(max-width: 767px) 20px, (max-width: 991px) 20px, (max-width: 1190px) 200px, 20px"
                    />
                  </span>
                ) : null}
                {team?.oTeam?.sTitle}
              </p>
              <div className="flex items-center justify-start">
                {team?.oTeam?.sTitle && (
                  <span className="w-1.5 h-1.5 bg-[#D9D9D9] mx-2 rounded-full"></span>
                )}
                <p className="whitespace-nowrap">
                  {team?.dBirthDate ? `${calculateAge(team?.dBirthDate)} Years` || '-' : '-'}
                </p>
              </div>
              <div className="flex items-center justify-start">
                <span className="w-[1px] h-6 bg-[#D9D9D9] mx-2"></span>
                <p className="whitespace-nowrap">{generateBettingStyle()}</p>
              </div>
              <span className="w-2 h-2 bg-t-secondary mx-2 rounded-full last:hidden"></span>
            </div>
            <div className="flex flex-wrap items-start mb-0 md:mb-4 gap-3 md:gap-3.5">
              {team?.aRanking?.map(rank => {
                if (rank.nRank && rank.eMatchType) {
                  return (
                    <p
                      key={rank.eMatchType}
                      className={
                        'py-1.5 px-3.5 capitalize text-[10px] md:text-sm font-medium flex flex-wrap items-center text-subSectionText border border-borderStroke rounded-[9px]'
                      }
                    >
                      {`#${rank.nRank} ${rank?.eRankType} in ${rank.eMatchType}`}
                    </p>
                  )
                }
              })}
            </div>
            <button
              className="bg-primary-500 md:inline-block hidden px-3 py-1.5 text-white rounded-lg w-fit font-semibold text-sm"
              onClick={() => setIsSearch(true)}
            >
              {/* <MyImage src={comparePlayer} width={18} height={18} /> */}
              Compare Player
            </button>
          </div>
        </div>
        <div className="hidden md:flex justify-center mt-2">
          {/* <GoogleAds {...addTop} /> */}
          <ReviveAds {...desktopTop} />
        </div>
        <div className="md:hidden flex justify-center mt-2">
          <ReviveAds {...mobSm} />
        </div>
      </section>
      {isSearch && (
        <ComparePlayerPopup
          isSecond
          playerId={team?._id}
          hide={() => setIsSearch(false)}
          slug={team?.oSeo?.sSlug}
        />
      )}
    </>
  )
}

export default PlayerHeader
